import React, { useMemo } from 'react';
import { getSupabaseClient } from '@/lib/supabase';
import { SupabaseConnectionContext } from '@/lib/supabase-connection-types';

interface SupabaseConnectionProviderProps {
  children: React.ReactNode;
}

/**
 * Simplified Supabase Connection Provider
 * Ensures a single, tab-safe Supabase client instance is provided to the app.
 */
export const SupabaseConnectionProvider: React.FC<SupabaseConnectionProviderProps> = ({ children }) => {
  // useMemo ensures the client is created only once per component lifecycle.
  const supabase = useMemo(() => getSupabaseClient(), []);

  return (
    <SupabaseConnectionContext.Provider value={{ supabase }}>
      {children}
    </SupabaseConnectionContext.Provider>
  );
};